export default __webpack_public_path__ + "static/fifteen-b0af6930c7d5c32b007c458da7b44c1b.svg";